import {IGoldReserve, IGoldReserveHistory} from '../models/GoldReserve';

export const SAVE_GOLD_RESERVE = 'SAVE_GOLD_RESERVE';
export const SAVE_GOLD_RESERVE_SUCCESS = 'SAVE_GOLD_RESERVE_SUCCESS';
export const SAVE_GOLD_RESERVE_ERROR = 'SAVE_GOLD_RESERVE_ERROR';

export const FETCH_GOLD_RESERVE = 'FETCH_GOLD_RESERVE';
export const FETCH_GOLD_RESERVE_SUCCESS = 'FETCH_GOLD_RESERVE_SUCCESS';
export const FETCH_GOLD_RESERVE_ERROR = 'FETCH_GOLD_RESERVE_ERROR';

export const FETCH_GOLD_RESERVE_HISTORY = 'FETCH_GOLD_RESERVE_HISTORY';
export const FETCH_GOLD_RESERVE_HISTORY_SUCCESS =
  'FETCH_GOLD_RESERVE_HISTORY_SUCCESS';
export const FETCH_GOLD_RESERVE_HISTORY_ERROR =
  'FETCH_GOLD_RESERVE_HISTORY_ERROR';

export interface SaveGoldReserve {
  type: typeof SAVE_GOLD_RESERVE;
}

export interface SaveGoldReserveSuccess {
  type: typeof SAVE_GOLD_RESERVE_SUCCESS;
  payload: IGoldReserve;
}

export interface SaveGoldReserveError {
  type: typeof SAVE_GOLD_RESERVE_ERROR;
}

export interface FetchGoldReserve {
  type: typeof FETCH_GOLD_RESERVE;
}

export interface FetchGoldReserveSuccess {
  type: typeof FETCH_GOLD_RESERVE_SUCCESS;
  payload: IGoldReserve;
}

export interface FetchGoldReserveError {
  type: typeof FETCH_GOLD_RESERVE_ERROR;
}

export interface FetchGoldReserveHistory {
  type: typeof FETCH_GOLD_RESERVE_HISTORY;
}

export interface FetchGoldReserveHistorySuccess {
  type: typeof FETCH_GOLD_RESERVE_HISTORY_SUCCESS;
  payload: IGoldReserveHistory;
}

export interface FetchGoldReserveHistoryError {
  type: typeof FETCH_GOLD_RESERVE_HISTORY_ERROR;
}

export type GoldReserveActions =
  | SaveGoldReserve
  | SaveGoldReserveSuccess
  | SaveGoldReserveError
  | FetchGoldReserve
  | FetchGoldReserveSuccess
  | FetchGoldReserveError
  | FetchGoldReserveHistory
  | FetchGoldReserveHistorySuccess
  | FetchGoldReserveHistoryError;
